import React from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import NotFound from "./components/errors/NotFound";
import About from "./pages/About";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Profile from "./pages/Profile";
import Register from "./pages/Register";
import EnvTest from "./pages/EnvTest";
import Restaurants from "./pages/Restaurants";
import Restaurant from "./pages/Restaurant";
import Payment from "./pages/Payment";
import ManageUser from "./pages/ManageUser";
import RequestResetPwd from "./pages/RequestResetPwd";
import VerifyAccount from "./pages/VerifyAccount";
import ResetPwd from "./pages/ResetPwd";
import ManagerProfile from "./pages/ManagerProfile";
import ManageRestaurant from "./pages/ManageRestaurant";
import ManageIngredients from "./pages/ManageIngredients";
import VaccinationCheck from "./pages/VaccinationCheck";
import Dashboard from "./pages/Dashboard";
import Category from "./pages/Category";
import Settings from "./pages/Settings";
import TwoFa from "./pages/TwoFa";
import AdminMenu from "./pages/AdminMenu";
import AdminManageRestaurants from "./pages/AdminManageRestaurants";
import UserDetailsConfig from "./pages/UserDetailsConfig";
import ChangePwd from "./pages/ChangePwd";

export default function Routes() {
    let location = useLocation<any>();
    let background = location.state && location.state.background;
    
    return (
        <div>
            <Switch location={background || location}>
                <Route exact path="/">
                    <Home />
                </Route>
                <Route exact path="/about">
                    <About />
                </Route>
                <Route exact path="/login">
                    <Login />
                </Route>
                <Route exact path="/register">
                    <Register />
                </Route>
                <Route exact path="/verifyaccount">
                    <VerifyAccount />
                </Route>
                <Route exact path="/restaurants">
                    <Restaurants />
                </Route>
                <Route exact path="/profile">
                    <Profile />
                </Route>
                <Route exact path="/vaccinationCheck">
                    <VaccinationCheck />
                </Route>
                <Route exact path="/manageuser">
                    <ManageUser />
                </Route>
                <Route exact path="/envtest">
                    <EnvTest />
                </Route>
                <Route path="/restaurant/:id">
                    <Restaurant />
                </Route>
                <Route path="/payment/:id">
                    <Payment />
                </Route>
                <Route exact path="/forgotpassword">
                    <RequestResetPwd />
                </Route>
                <Route exact path="/resetpassword">
                    <ResetPwd />
                </Route>
                <Route exact path="/manager">
                    <ManagerProfile />
                </Route>
                <Route exact path="/admin">
                    <AdminMenu />
                </Route>
                <Route exact path="/adminRestaurant">
                    <AdminManageRestaurants />
                </Route>
                <Route exact path="/managerestaurant">
                    <ManageRestaurant />
                </Route>
                <Route exact path="/managerestaurant/:id">
                    <ManageRestaurant />
                </Route>
                <Route exact path="/manageingredients">
                    <ManageIngredients />
                </Route>
                <Route exact path="/manageingredients/:id">
                    <ManageIngredients />
                </Route>
                <Route exact path="/dashboard">
                    <Dashboard />
                </Route>
                <Route exact path="/categories">
                    <Category />
                </Route>
                <Route exact path="/settings">
                    <Settings />
                </Route>
                <Route exact path="/twofasetup">
                    <TwoFa />
                </Route>
                <Route exact path="/userdetailsconfig">
                    <UserDetailsConfig />
                </Route>
                <Route exact path="/changepassword">
                    <ChangePwd />
                </Route>
                <Route>
                    <NotFound />
                </Route>
            </Switch>
        </div>

    );
}